import { type DocumentNode, gql } from '@apollo/client';

const tokenAuth: DocumentNode = gql`
  mutation tokenAuth($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
      payload
      refreshExpiresIn
    }
  }
`;

export default tokenAuth;
